import { SplitContent } from '@leshen/ui'

export default SplitContent
